"use client";
import { FallBackPage, ThemeModeWrapper } from "@highway/design-system";
import "./global.css";

export default function GlobalError({ _reset }: { error: Error & { digest?: string }; _reset: () => void }) {
    return (
        <html lang="en">
            <body>
                <ThemeModeWrapper>
                    <FallBackPage page="error" />
                </ThemeModeWrapper>
            </body>
        </html>
    );
}
